/*
 * Flamingo Royale Art – direct connection to TC Wishlist Engine.
 * The product/variant/handle come from Shopify Liquid on the current product
 * page. Do not proxy a click to a different native wishlist heart, which may
 * belong to a recommended or previous/next product.
 *
 * TC Wishlist Engine 117 SDK exports window.WishlistApp.addItem,
 * removeItem, isInWishlist and events; it dispatches wishlist:sdk-ready.
 */
(() => {
  'use strict';

  function init() {
    const section = document.querySelector('[data-motif-favorite]');
    if (!section) return;

    const button = section.querySelector('[data-motif-wishlist-button]');
    const label = section.querySelector('[data-motif-wishlist-label]');
    const status = section.querySelector('[data-motif-wishlist-status]');
    const productId = String(section.dataset.productId || '').trim();
    const variantId = String(section.dataset.variantId || '').trim();
    const productHandle = String(section.dataset.productHandle || '').trim();
    if (!button || !label || !status || !productId || !productHandle) return;

    const getApp = () => {
      const app = window.WishlistApp;
      return app && typeof app.addItem === 'function' &&
        typeof app.removeItem === 'function' &&
        typeof app.isInWishlist === 'function' ? app : null;
    };

    let busy = false;
    let subscribedApp = null;

    const isSaved = (app) => {
      if (!app) return null;
      try { return Boolean(app.isInWishlist(productId)); }
      catch (error) { console.warn('[Flamingo Wishlist] Status konnte nicht gelesen werden', error); return null; }
    };

    function update() {
      const app = getApp();
      const saved = isSaved(app);
      button.classList.toggle('is-saved', saved === true);
      button.classList.toggle('is-ready', Boolean(app));
      button.setAttribute('aria-pressed', saved === true ? 'true' : 'false');
      label.textContent = saved === true ? 'Als Favorit gespeichert' : 'Dieses Motiv als Favorit speichern';
      if (app && subscribedApp !== app) subscribe(app);
      return {app, saved};
    }

    function subscribe(app) {
      subscribedApp = app;
      const events = app.events;
      if (!events || typeof events.subscribe !== 'function') return;
      ['wishlist:item-added', 'wishlist:item-removed', 'wishlist:state-changed',
        'wishlist:loaded', 'wishlist:merged', 'wishlist:cleared'].forEach((eventName) => {
        try { events.subscribe(eventName, update); }
        catch (error) { console.warn('[Flamingo Wishlist] Listener konnte nicht verbunden werden:', eventName, error); }
      });
    }

    button.removeAttribute('disabled');
    button.removeAttribute('aria-disabled');

    button.addEventListener('click', async () => {
      if (busy) return;
      const {app, saved} = update();
      if (!app) {
        status.textContent = 'Die Favoritenfunktion ist noch nicht geladen. Bitte versuche es gleich erneut.';
        return;
      }
      if (saved === null) {
        status.textContent = 'Der Favoritenstatus ist momentan nicht verfügbar. Bitte versuche es erneut.';
        return;
      }
      busy = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      status.textContent = '';
      try {
        // Public functions of TC Wishlist Engine SDK. Its own guest wishlist,
        // app-side analytics, and stored product state remain authoritative.
        if (saved) {
          await app.removeItem(productId);
        } else {
          await app.addItem(productId, variantId || null, productHandle);
        }
        const after = isSaved(app);
        update();
        if (after === !saved) {
          status.textContent = after
            ? 'Gespeichert – danke für deine Auswahl. Du findest das Bild in deiner Wunschliste wieder.'
            : 'Das Bild wurde aus deinen Favoriten entfernt.';
        } else {
          status.textContent = 'Die Änderung konnte nicht bestätigt werden. Bitte prüfe deine Favoritenliste.';
        }
      } catch (error) {
        console.error('[Flamingo Wishlist] Favoritenaktion fehlgeschlagen:', error);
        status.textContent = 'Das Speichern hat leider nicht funktioniert. Bitte versuche es erneut.';
        update();
      } finally {
        busy = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });

    window.addEventListener('wishlist:sdk-ready', () => {
      status.textContent = '';
      update();
    });
    window.addEventListener('pageshow', update);
    update();
    // The Shopify app can be loaded late without sending its ready event to
    // scripts registered after it. Recheck briefly; this does not change state.
    if (!getApp()) {
      let retries = 0;
      const check = window.setInterval(() => {
        retries++;
        update();
        if (getApp() || retries >= 30) window.clearInterval(check);
      }, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {once: true});
  } else {
    init();
  }
})();
